import React, { useRef } from 'react';
import styled from 'styled-components';

import { useModal } from '../../../Providers/ModalContext';
import Modal from '../../../Global/Modal';
import RichText from '../../../Global/RichText';

import CloseIcon from '../../../../Images/icons/close-icon.png';
import DirectorsBg from '../../../../Images/background/bg_directors.png';
import LogoStudio from '../../../../Images/logos/logo-studio.png';

import DirNuno from '../../../../Images/modals/directors/all/dir_nuno.png';
import DirBernardo from '../../../../Images/modals/directors/all/dir_bernardo.png';
import DirMaria from '../../../../Images/modals/directors/all/dir_maria.png';
import DirCarlos from '../../../../Images/modals/directors/all/dir_carlos.png';
import DirRodrigo from '../../../../Images/modals/directors/all/dir_rodrigo.png';

import DirNunoMob from '../../../../Images/modals/directors/nuno/bg_nuno.png';
import DirBernardoMob from '../../../../Images/modals/directors/bernardo/bg_bernardo.png';
import DirMariaMob from '../../../../Images/modals/directors/maria/bg_maria.png';
import DirCarlosMob from '../../../../Images/modals/directors/carlos/bg_carlos.png';
import DirRodrigoMob from '../../../../Images/modals/directors/rodrigo/bg_rodrigo.png';

import {
  Directors_Title,
  Director_Nuno,
  Director_Bernardo,
  Director_Maria,
  Director_Carlos,
  Director_Rodrigo,
} from '../../../../utils/EN/Modals/directors';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 25px 0px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 4rem;
  overflow: hidden;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 25px 0 0 0 !important;
    gap: 0rem;
  }
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;
  padding-right: 5%;
  padding-left: 110px;

  @media (max-width: ${breakpoints.mobile}) {
    padding-left: 30px;
  }

  p,
  h2,
  h3 {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(250, 115, 19, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const DirectorsContainer = styled.div`
  width: 100%;
  height: 750px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
  position: relative;

  @media (max-width: ${breakpoints.tablet}) {
    height: 100%;
    flex-direction: column;
  }
`;

const DirectorCard = styled.div`
  position: absolute;
  width: 460px;
  height: 750px;

  cursor: pointer;
  object-fit: cover;
  transition: 0.4s;

  @media (max-width: ${breakpoints.desktop}) {
    width: 360px;
    height: 590px;
  }

  @media (max-width: ${breakpoints.tablet}) {
    position: relative;
    width: 100%;
    height: 460;
    left: 0;
  }

  @media (max-width: ${breakpoints.mobile}) {
    position: relative;
    width: 100%;
    height: 227px;
    left: 0;
  }

  &:hover {
    h3 {
      text-shadow: 0px 0px 20px rgba(255, 255, 255, 1);
    }
  }

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 160px;
  }

  img {
    width: auto;
    height: 100%;
    display: block;

    @media (max-width: ${breakpoints.tablet}) {
      display: none;
    }

    &.mobile {
      width: 100%;
      height: 100%;
      display: none;
      object-fit: cover;

      @media (max-width: ${breakpoints.tablet}) {
        display: block;
      }
    }
  }

  h3 {
    text-align: center;
    cursor: pointer;

    position: absolute;
    bottom: 5%;
    right: 0;
    left: 0;
    margin: 0 auto;
    z-index: 1;

    transition: all 0.3s ease;

    @media (max-width: ${breakpoints.tablet}) {
      bottom: 0;
      top: 50%;
      transform: translate(20%, -30%);
    }
  }

  ${({ index }) => {
    const positions = {
      1: { left: '-5%', z: 1, scale: 1 },
      2: { left: '17%', z: 2, scale: 1 },
      3: { left: '37%', z: 5, scale: 1 },
      4: { left: '56%', z: 2, scale: 1 },
      5: { left: '79%', z: 1, scale: 1 },
    };

    return `
      left: ${positions[index].left};
      z-index: ${positions[index].z};
      transform: scale(${positions[index].scale});
    `;
  }}
`;

const ModalDirectors = () => {
  const { closeModal } = useModal();

  const { openModal } = useModal();

  const handleClick = (e) => {
    const target = e.currentTarget.dataset.target;
    openModal(target);
  };

  return (
    <>
      <Modal
        id="directors"
        bgImg={DirectorsBg}
        bgColor={'rgba(0, 0, 0, 1)'}
        bgPosition={'top center'}
        padding={'40px 0px'}
        mobPadding={'20px 0px'}
      >
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoStudio}
                onClick={closeModal}
                aria-label="Close modal"
                alt="Kuter Studio"
              />
            </LogoContent>
            <RichText dataText={Directors_Title} />
          </TitleContent>
          <DirectorsContainer>
            <DirectorCard
              index={1}
              onClick={handleClick}
              data-target="director-nuno"
            >
              <img src={DirNuno} alt="Nuno Gomez" />
              <img src={DirNunoMob} className="mobile" alt="Nuno Gomez" />
              <RichText
                dataText={Director_Nuno}
                onClick={handleClick}
                data-target="director-nuno"
              />
            </DirectorCard>
            <DirectorCard
              index={2}
              onClick={handleClick}
              data-target="director-bernardo"
            >
              <img src={DirBernardo} alt="Bernardo Vazquez" />
              <img
                src={DirBernardoMob}
                className="mobile"
                alt="Bernardo Vazquez"
              />
              <RichText
                dataText={Director_Bernardo}
                onClick={handleClick}
                data-target="director-bernardo"
              />
            </DirectorCard>
            <DirectorCard
              index={3}
              onClick={handleClick}
              data-target="director-maria"
            >
              <img src={DirMaria} alt="Maria Jose Noriega" />
              <img
                src={DirMariaMob}
                className="mobile"
                alt="Maria Jose Noriega"
              />
              <RichText
                dataText={Director_Maria}
                onClick={handleClick}
                data-target="director-maria"
              />
            </DirectorCard>
            <DirectorCard
              index={4}
              onClick={handleClick}
              data-target="director-carlos"
            >
              <img src={DirCarlos} alt="Carlos Morett" />
              <img src={DirCarlosMob} className="mobile" alt="Carlos Morett" />
              <RichText
                dataText={Director_Carlos}
                onClick={handleClick}
                data-target="director-carlos"
              />
            </DirectorCard>
            <DirectorCard
              index={5}
              onClick={handleClick}
              data-target="director-rodrigo"
            >
              <img src={DirRodrigo} alt="Rodrigo Robles" />
              <img
                src={DirRodrigoMob}
                className="mobile"
                alt="Rodrigo Robles"
              />
              <RichText
                dataText={Director_Rodrigo}
                onClick={handleClick}
                data-target="director-rodrigo"
              />
            </DirectorCard>
          </DirectorsContainer>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalDirectors;
